import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { FindParticipantForRebiddingQueryResponse, FindParticipantForRebiddingQueryParams } from "../../types/FindParticipantForRebidding";

/**
     * @link /api/purchase-tenders/private/v1/participant/view_for-rebidding
     */
export async function findParticipantForRebidding (params: FindParticipantForRebiddingQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<FindParticipantForRebiddingQueryResponse>["data"]> {
    const { data: resData } = await client<FindParticipantForRebiddingQueryResponse>({
        method: "get",
        url: `/api/purchase-tenders/private/v1/participant/view_for-rebidding`,
        params,
        ...options
    });
    
    return resData;
};